export default __webpack_public_path__ + "static/media/diameter_cage.4de83288.svg";